enum Mutations {
  setCategories = 'setCategories',
  setTypes = 'setTypes',
  setTextFilters = 'setTextFilters',
  setCreators = 'setCreators',
  setItems = 'setItems',
}

export default Mutations;
